import React from 'react'
import { Spinner } from 'react-bootstrap'
import './loadingScreen.css'

function LoadingScreen() {
  return (
    <div className='loading_screen'>
        <div style={{ height: "100vh"}}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png" alt="" style={{ height: "10rem", marginTop: "15rem"}}/>
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "white" }}>
                <Spinner
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true"
                />
                {`  Loading...`}
            </div>
        </div>
        
        
    </div>
  )
}

export default LoadingScreen